class SalutSpecialist extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-author-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => this.open(trigger.dataset.authorOpen));
    });

    this.querySelectorAll('.salut-article__dialog').forEach((dialog) => {
      dialog.querySelector('[data-author-close]')?.addEventListener('click', () => dialog.close());

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });

      dialog.addEventListener('close', () => this.releaseScroll());
    });
  }

  disconnectedCallback() {
    this.releaseScroll();
  }

  open(id) {
    const dialog = this.querySelector(`#${id}`);
    if (!dialog) return;

    dialog.showModal();
    document.body.classList.add('overflow-hidden');
  }

  releaseScroll() {
    if (document.querySelector('.salut-article__dialog[open]')) return;
    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('salut-specialist')) customElements.define('salut-specialist', SalutSpecialist);
